export const PARTNER_STATUS_PAGE_URL = 'https://statuspage.tamara.com/'
export const PARTNER_SUPPORT_URL = 'https://support.tamara.co'
export const PARTNER_SUPPORT_URL_AR = `${PARTNER_SUPPORT_URL}/ar`
export const PARTNER_SUPPORT_URL_EN = `${PARTNER_SUPPORT_URL}/en-US`

/**
 * Resolve the help center URL for a locale.
 * Only `ar` and `en-US` are served by support.tamara.co, so anything
 * that is not Arabic falls back to English.
 *
 * @param {string} [locale] - Locale in any supported shape (`ar`, `ar_SA`, `ar-SA`, ...)
 * @returns {string}
 */
export const getHelpCenterUrl = (locale) => {
  const isArabic = String(locale || '')
    .toLowerCase()
    .startsWith('ar')

  return isArabic ? PARTNER_SUPPORT_URL_AR : PARTNER_SUPPORT_URL_EN
}
